export const user_Loading_status = "user_Loading_status";

export const user_Get_Success_status = "user_Get_Success_status";

export const user_Error_status = "user_Error_status";

export const user_Delete_Success_status = "user_Delete_Success_status"

export const user_Update_Success_status = "user_Update_Success_status"
